module.exports = __webpack_public_path__ + "ee0a74e45a9d1c9fe41a05a494ac2540.svg";